import React, { useMemo } from 'react';

import arrayMutators from 'final-form-arrays';
import { Form, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { useSelector } from 'react-redux';

import AddMinusButton from 'components/shared/AddMinusButton';
import Divider from 'components/shared/Divider';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import LabelWrapper from 'components/shared/FormAdapters/FormDefault/Label/Wrapper';
import Loader from 'components/shared/Loader';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import UnsavedChangesFormWatcher from 'components/shared/UnsavedChangesFormWatcher';
import { pageDataSelector } from 'store/page/selectors';
import { capitalizeAllWordsForInput } from 'utils/common';

import { BuilderFooterButton } from '../../shared/BuilderFooterButton';
import { usePageContext } from '../../shared/context';
import PageFormButtons from '../../shared/PageFormButtons';

function Details() {
  const page = useSelector(pageDataSelector);
  const { useNextStepFormHandler } = usePageContext();
  const handleNextStep = useNextStepFormHandler();

  const memoizedPage = useMemo(() => {
    return {
      video: [{}],
      ...page,
    };
  }, [page]);

  return (
    <Form
      onSubmit={handleNextStep}
      initialValues={memoizedPage}
      mutators={{
        ...arrayMutators,
      }}
      render={({
        handleSubmit,
        submitting,
        invalid,
        form: {
          mutators: { push },
        },
      }) => (
        <form onSubmit={handleSubmit} autoComplete="nope">
          <UnsavedChangesFormWatcher />

          {submitting && <Loader isFillBlock />}
          <FormTitle center>{page.id ? 'Edit Page Content' : 'Create New Content'}</FormTitle>

          <FormTitle hint="Enter information to organize this content so that you can find it easily later.">
            I. Page Details
          </FormTitle>

          <LabelWrapper>
            <Label>Page Name</Label>
            <Text accent>The name of a page will appear throughout the client facing itinerary.</Text>
          </LabelWrapper>
          <Field
            component={FormGroupAdapter}
            name="name"
            placeholder="Creating New Content"
            type="text"
            onInput={capitalizeAllWordsForInput}
          />

          <LabelWrapper>
            <Label>Tags</Label>
            <Text accent>Tags make it easier to find and categorize content.</Text>
          </LabelWrapper>
          <Field component={FormGroupAdapter} name="tags" placeholder="Help" type="tags" />

          <Field
            component={FormGroupAdapter}
            name="article_description"
            placeholder="The Internet is a visual medium and images play a crucial role in your site's design, message, and content. In the videos below, we'll explore why images matter, discuss guidelines for formatting..."
            type="textarea"
            label="Article Description"
            minRows={8}
          />

          <FormTitle hint="Select a few photos that are representative of this property to appear in the Agent Resource Library. ">
            II. Photos & Videos
          </FormTitle>

          <LabelWrapper>
            <Label>Photos</Label>
          </LabelWrapper>
          {/* <div>Dropzone here</div> */}

          <Label>Video</Label>

          <FieldArray name="video">
            {({ fields }) =>
              fields.map((name, index) => (
                <div key={name} className="fieldArrayWrapper">
                  <Divider />

                  <Field component={FormGroupAdapter} name="nameAndLink" type="inputGroup">
                    <Field
                      component={FormGroupAdapter}
                      name={`${name}.name`}
                      placeholder="Kenya"
                      type="text"
                      label="Name"
                    />

                    <Field
                      component={FormGroupAdapter}
                      name={`${name}.link`}
                      placeholder="Maasai Mara"
                      type="text"
                      label="Link"
                    />
                  </Field>
                  {index !== 0 && (
                    <AddMinusButton
                      variant="minus"
                      onClick={() => fields.remove(index)}
                      className="fieldArrayRemove fieldArrayRemove-checkLabel"
                    />
                  )}
                </div>
              ))
            }
          </FieldArray>

          <FormActions isCenter>
            <AddMinusButton onClick={() => push('video', undefined)} />
          </FormActions>

          <FormActions isRight>
            <BuilderFooterButton htmlType="submit" disabled={submitting || invalid}>
              Next
            </BuilderFooterButton>
          </FormActions>

          <PageFormButtons />
        </form>
      )}
    />
  );
}

export default Details;
